import React from "react";
import Swal from "sweetalert2";
import axios from "axios";
import CryptoJS from "crypto-js";

export const ADDR = "https://accounts.paybito.com/api/home/";
export const RECAPTCHASITEKEY = "6LeJ1IoqAAAAAHCRhEuSpIsMLSPf5wRyX_jTTeYD";
export const WEBSERVICE = "https://accounts.paybito.com/api/";
export const ACCREDITEDKYCWEBSERVICE = "https://accounts.paybito.com/api/user/";
export const TRADESERVICE =
  "https://stream.paybito.com/SocketStream/api/marketPrice";
export const CACHESERVICE = "https://accounts.paybito.com/CacheService/api";

export const REPORTSERVICE = WEBSERVICE + "report/";

export const CURRENCYNAME = "USD";

export const DEMOBROKERDOMAIN = "https://portal.paybito.com";

/**
 * The broker this build belongs to.
 *
 * This is a single-broker white-label, so the broker is a build-time fact, not
 * something to discover at runtime. Header.js used to fall back to
 * `exchangeDetailsByDomain?domain=<window.location.origin>` when no broker id
 * was in the URL or localStorage — that call has been removed. It could not
 * work off a broker domain anyway (localhost, staging and any unregistered
 * host all resolve to PayBito's default broker, which is how the wrong
 * branding used to appear), and a white-label should never ask a shared
 * service "who am I?".
 *
 * Change this value to re-point the build at a different broker.
 */
export const BROKERID = "ATHA24102025105924";
export const P2PWEBSERVICE =
  "https://accounts.paybito.com/api/crypto/banking/p2p";

export const CHATSECRETKEY = process.env.REACT_APP_CHATSECRETKEY || "";

export const ASSETICONBASEURL =
  "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/";

export const MININGWEBSERVICE = "https://accounts.paybito.com/api/miningPool";

export const POOLWEBSERVICE = "https://pool.paybito.com:7443/mining-pool/api";

export const selectedSellingAssetText = localStorage.getItem(
  "selling_crypto_asset"
);
export const selectedBuyingAssetText = localStorage.getItem(
  "buying_crypto_asset"
);

export const OPTIONS_FOR_FINGERPRINT = {
  excludes: {
    audio: true,
    canvas: true,
    webgl: true,
    fonts: true,
    adBlock: true,
    enumerateDevices: true,
    plugins: true,
    pixelRatio: true,
    deviceDpi: true,
    screenResolution: true,
    availableScreenResolution: true,
    doNotTrack: true,
    hardwareConcurrency: true,
    cpuClass: true,
    colorDepth: true,
    timezone: true,
    timezoneOffset: true,
    sessionStorage: true,
    localStorage: true,
    indexedDb: true,
    openDatabase: true,
  },
};

const currencySymbolList = [
  { currency: "DZD", symbol: "د.ج" },
  { currency: "USD", symbol: "$" },
  { currency: "EUR", symbol: "€" },
  { currency: "AOA", symbol: "Kz" },
  { currency: "XCD", symbol: "$" },
  { currency: "ARS", symbol: "$" },
  { currency: "AMD", symbol: "֏" },
  { currency: "AWG", symbol: "ƒ" },
  { currency: "SHP", symbol: "£" },
  { currency: "AUD", symbol: "$" },
  { currency: "AZN", symbol: "₼" },
  { currency: "BSD", symbol: "$" },
  { currency: "BHD", symbol: ".د.ب" },
  { currency: "BDT", symbol: "৳" },
  { currency: "BBD", symbol: "$" },
  { currency: "BZD", symbol: "BZ$" },
  { currency: "XOF", symbol: "CFA" },
  { currency: "BMD", symbol: "$" },
  { currency: "BTN", symbol: "Nu." },
  { currency: "BOB", symbol: "Bs." },
  { currency: "BWP", symbol: "P" },
  { currency: "BRL", symbol: "R$" },
  { currency: "BND", symbol: "$" },
  { currency: "BIF", symbol: "FBu" },
  { currency: "KHR", symbol: "៛" },
  { currency: "XAF", symbol: "FCFA" },
  { currency: "CAD", symbol: "$" },
  { currency: "CVE", symbol: "Esc" },
  { currency: "KYD", symbol: "$" },
  { currency: "CLP", symbol: "$" },
  { currency: "CNY", symbol: "¥" },
  { currency: "KMF", symbol: "CF" },
  { currency: "NZD", symbol: "$" },
  { currency: "CRC", symbol: "₡" },
  { currency: "ANG", symbol: "ƒ" },
  { currency: "CZK", symbol: "Kč" },
  { currency: "DKK", symbol: "kr" },
  { currency: "DJF", symbol: "Fdj" },
  { currency: "DOP", symbol: "RD$" },
  { currency: "EGP", symbol: "ج.م" },
  { currency: "ERN", symbol: "Nfk" },
  { currency: "SZL", symbol: "L" },
  { currency: "FKP", symbol: "£" },
  { currency: "FJD", symbol: "$" },
  { currency: "XPF", symbol: "₣" },
  { currency: "GMD", symbol: "D" },
  { currency: "GEL", symbol: "₾" },
  { currency: "GHS", symbol: "₵" },
  { currency: "GIP", symbol: "£" },
  { currency: "GTQ", symbol: "Q" },
  { currency: "GBP", symbol: "£" },
  { currency: "GNF", symbol: "FG" },
  { currency: "GYD", symbol: "$" },
  { currency: "HTG", symbol: "G" },
  { currency: "HNL", symbol: "L" },
  { currency: "HUF", symbol: "Ft" },
  { currency: "ISK", symbol: "kr" },
  { currency: "INR", symbol: "₹" },
  { currency: "IDR", symbol: "Rp" },
  { currency: "ILS", symbol: "₪" },
  { currency: "JMD", symbol: "J$" },
  { currency: "JPY", symbol: "¥" },
  { currency: "JOD", symbol: "JD" },
  { currency: "KZT", symbol: "₸" },
  { currency: "KES", symbol: "KSh" },
  { currency: "KWD", symbol: "د.ك" },
  { currency: "KGS", symbol: "с" },
  { currency: "LAK", symbol: "₭" },
  { currency: "LSL", symbol: "L" },
  { currency: "LRD", symbol: "$" },
  { currency: "CHF", symbol: "Fr." },
  { currency: "MOP", symbol: "MOP$" },
  { currency: "MGA", symbol: "Ar" },
  { currency: "MWK", symbol: "MK" },
  { currency: "MYR", symbol: "RM" },
  { currency: "MVR", symbol: "Rf" },
  { currency: "MRU", symbol: "UM" },
  { currency: "MUR", symbol: "₨" },
  { currency: "MDL", symbol: "L" },
  { currency: "MNT", symbol: "₮" },
  { currency: "MAD", symbol: "د.م." },
  { currency: "MZN", symbol: "MT" },
  { currency: "NAD", symbol: "N$" },
  { currency: "NPR", symbol: "₨" },
  { currency: "NGN", symbol: "₦" },
  { currency: "NOK", symbol: "kr" },
  { currency: "OMR", symbol: "ر.ع." },
  { currency: "PKR", symbol: "₨" },
  { currency: "PAB", symbol: "B/." },
  { currency: "PGK", symbol: "K" },
  { currency: "PYG", symbol: "₲" },
  { currency: "PEN", symbol: "S/." },
  { currency: "PHP", symbol: "₱" },
  { currency: "PLN", symbol: "zł" },
  { currency: "QAR", symbol: "ر.ق" },
  { currency: "RWF", symbol: "FRw" },
  { currency: "WST", symbol: "WS$" },
  { currency: "STN", symbol: "Db" },
  { currency: "SAR", symbol: "ر.س" },
  { currency: "SCR", symbol: "₨" },
  { currency: "SLL", symbol: "Le" },
  { currency: "SEK", symbol: "kr" },
  { currency: "CHF", symbol: "CHF" },
  { currency: "TWD", symbol: "NT$" },
  { currency: "TJS", symbol: "ЅМ" },
  { currency: "TZS", symbol: "TSh" },
  { currency: "THB", symbol: "฿" },
  { currency: "TTD", symbol: "TT$" },
  { currency: "TRY", symbol: "₺" },
  { currency: "TMT", symbol: "T" },
  { currency: "UGX", symbol: "USh" },
  { currency: "UYU", symbol: "$" },
  { currency: "UZS", symbol: "so'm" },
  { currency: "VUV", symbol: "VT" },
  { currency: "VND", symbol: "₫" },
  { currency: "YER", symbol: "﷼" },
  { currency: "ZMW", symbol: "ZK" },
  { currency: "ZWL", symbol: "Z$" },
  { currency: "AED", symbol: "د.إ" },
  { currency: "SGD", symbol: "S$" },
];

/*** function defination for showing toast ***/
export const showToast = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    showCloseButton: true,
    // onOpen: (toast) => {
    //   //toast.addEventListener('mouseenter', Swal.stopTimer)
    //   //toast.addEventListener('mouseleave', Swal.resumeTimer)
    // },
    didOpen: (toast) => {
      const maxZ = Math.max(
        ...Array.from(
          document.querySelectorAll("body *"),
          (el) => parseFloat(window.getComputedStyle(el).zIndex) || 0
        )
      );
      toast.style.zIndex = maxZ + 10;
    },
    customClass: {
      popup: "custom-toast-width",
    },
  });

  Toast.fire({
    icon: type,
    title: message,
  });
};

/*** function definition for showing error dialog ***/
// Pass the full error object so ErrorDialog can distinguish error types
export const showErrorDialog = (errorObj) => {
  const event = new CustomEvent("show-error-dialog", { detail: errorObj });
  window.dispatchEvent(event);
};

export const showCustomAlert = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end", // show at top center like the image
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    showCloseButton: false,
    customClass: {
      popup: "my-toast-popup",
      title: "my-toast-title",
    },
    didOpen: (toast) => {
      // fix z-index so it appears on top
      const maxZ = Math.max(
        ...Array.from(
          document.querySelectorAll("body *"),
          (el) => parseFloat(window.getComputedStyle(el).zIndex) || 0
        )
      );
      toast.style.zIndex = maxZ + 10;
    },
  });

  Toast.fire({
    icon: type, // 'success', 'error', 'warning', 'info', 'question'
    title: message,
  });
};

// export const showToast = (type, message) => {
//   const typeClass =
//     type === "success"
//       ? "toast-success"
//       : type === "error"
//       ? "toast-error"
//       : "toast-info";

//   const iconHtml =
//     type === "success"
//       ? `<i class="fas fa-check-circle"></i>`
//       : type === "error"
//       ? `<i class="fas fa-times-circle"></i>`
//       : `<i class="fas fa-info-circle"></i>`;

//   const Toast = Swal.mixin({
//     toast: true,
//     position: "bottom-end",
//     showConfirmButton: false,
//     timer: 3000,
//     timerProgressBar: true,
//     showCloseButton: false, // Hide default close button
//     didOpen: (toast) => {
//       // Attach close event to custom close button
//       toast.querySelector(".close-icon").addEventListener("click", () => {
//         Swal.close();
//       });

//       // Pause timer on hover
//       toast.addEventListener("mouseenter", Swal.stopTimer);
//       toast.addEventListener("mouseleave", Swal.resumeTimer);
//     },
//     customClass: {
//       popup: `custom-toast ${typeClass}`, // Apply color styling based on type
//       timerProgressBar: "custom-toast-progress",
//     },
//   });

//   Toast.fire({
//     html: `
//       <div class="custom-toast-content">
//       <span class="toast-icon">${iconHtml}</span>
//         <div class="custom-toast-text">${message}</div>
//         <i class="fas fa-times close-icon"></i>
//       </div>
//     `,
//   });
// };

/*** function defination for confirm message  ***/
export const swalAlert = (text, type) => {
  Swal.fire({
    // title: title,
    text: text,
    icon: type,
    // showCancelButton: true,
    confirmButtonColor: "#3085d6",
    // cancelButtonColor: '#d33',
    confirmButtonText: "Ok",
  });
  // .then((result) => {
  //   if (result.value) {
  //       callback();
  //   }
  // })
};

/* method defination for sending otp through sms */
export async function handleSendOtpInSms(payload, param) {
  try {
    const response = await axios({
      url: WEBSERVICE + "user/sendMobileOtp/" + param,
      method: "POST",
      headers: { "content-Type": "application/json" },
      data: JSON.stringify(payload),
    });

    const result = response.data;

    if (result.error.error_data !== 0) {
      showToast("error", result.error.error_msg);
      return false;
    } else {
      if (param === "changephone") {
        showToast(
          "success",
          "Input OTP has sent to your both registered & new phone no"
        );
      } else {
        showToast("success", "Input OTP sent to your existing phone no");
      }
      return true;
    }
  } catch (error) {
    showToast("error", "Failed to send OTP. Please try again.");
    return false;
  }
}

export function handleGetAssetCode(counter, base) {
  // Retrieve 'spot_assets' from localStorage and parse it into an array
  const assets = JSON.parse(localStorage.getItem("spot_assets"));

  let assetCode = "";

  // Loop through the assets and check for a matching counter and base currency
  if (assets) {
    for (let i = 0; i < assets.length; i++) {
      if (
        counter.toUpperCase() === assets[i]["currencyCode"].toUpperCase() &&
        base.toUpperCase() === assets[i]["baseCurrency"].toUpperCase()
      ) {
        assetCode = assets[i]["assetCode"];
        break;
      }
    }
  }

  return assetCode;
}

export function handleGetAssetId(counter, base) {
  // Retrieve 'spot_assets' from localStorage and parse it into an array
  const assets = JSON.parse(localStorage.getItem("spot_assets"));
  // console.log('all assets',assets);

  let assetId = {};

  // Loop through the assets and check for a matching counter and base currency
  if (assets) {
    for (let i = 0; i < assets.length; i++) {
      if (
        counter.toUpperCase() === assets[i]["currencyCode"].toUpperCase() &&
        base.toUpperCase() === assets[i]["baseCurrency"].toUpperCase()
      ) {
        assetId["baseCurrencyId"] = assets[i]["baseCurrencyId"];
        assetId["currencyId"] = assets[i]["currencyId"];
        // console.log('assetId',assetId);

        break;
      }
    }
  }
  console.log("assetId", assetId);

  return assetId;
}

export const getDashBoardInfo = async () => {
  //     const [identificationStatus, setIdentificationStatus] = useState("");
  // const [identificationStatustwo, setIdentificationStatustwo] = useState("");
  // const [bankDetailStatus, setBankDetailStatus] = useState("");
  try {
    const infoObj = { uuid: localStorage.getItem("uuid") };

    const response = await axios.post(
      WEBSERVICE + "/user/GetUserAppSettings",
      JSON.stringify(infoObj),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      }
    );

    const result = response.data;

    if (result.error.error_data !== 0) {
      return;
    }

    localStorage.setItem(
      "user_app_settings_list",
      JSON.stringify(result.userAppSettingsResult)
    );

    localStorage.setItem(
      "twoFactorAuth",
      result.userAppSettingsResult.two_factor_auth
    );

    const environmentSettingsListObj = result.settingsList.reduce(
      (acc, setting) => {
        acc[`${setting.name}${setting.currencyId}`] = setting;
        return acc;
      },
      {}
    );

    localStorage.setItem(
      "environment_settings_list",
      JSON.stringify(environmentSettingsListObj)
    );
    localStorage.setItem(
      "user_app_settings_list_tire",
      JSON.stringify(result.tierWiseTransactionSettingsList)
    );

    const userDocsStatus = result.userAppSettingsResult.user_docs_status;
    const userTierDocsStatus = result.userAppSettingsResult.userTierDocsStatus;
    const bankDetailsStatus = result.userAppSettingsResult.bank_details_status;

    // Handling Tier 2 verification status
    let idStatus = "";
    if (userDocsStatus === "") {
      idStatus = "You are in Tier 1, please submit documents for Tier 2.";
      // showToast(
      //   "info",
      //   "PLEASE SUBMIT DOCUMENTS, ENSURE THAT ALL DOCUMENTS ARE IN JPG, JPEG, PNG, DOC OR PDF FORMAT. GIF and other formats are not permitted."
      // );
    } else if (userDocsStatus === "1") {
      idStatus = "Tier 2 Identity verification documents verified.";
    } else if (userDocsStatus === "0" || userDocsStatus === "2") {
      idStatus = "Tier 2 Identity verification documents submitted.";
    }
    // setIdentificationStatus(idStatus);

    // Handling Tier 3 verification status
    let idStatusTwo = "";
    if (userTierDocsStatus === "") {
      idStatusTwo = "You are already verified for Tier 2.";
    } else if (userTierDocsStatus === "0") {
      idStatusTwo = "Tier 3 Identity verification documents submitted.";
    } else if (userTierDocsStatus === "1") {
      idStatusTwo = "Tier 3 Identity verification documents verified.";
    } else if (userTierDocsStatus === "2") {
      idStatusTwo =
        "Tier 3 Identity verification documents declined, please submit again.";
    }
    // setIdentificationStatustwo(idStatusTwo);

    // Handling Bank details verification status
    let bankStatus = "";
    if (bankDetailsStatus === "") {
      bankStatus = "Bank details not submitted.";
    } else if (bankDetailsStatus === "0") {
      bankStatus = "Bank details submitted for Verification.";
    } else if (bankDetailsStatus === "2") {
      bankStatus = "Bank details verified.";
    } else if (bankDetailsStatus === "3") {
      bankStatus = "Bank documents declined, please submit again.";
    }
    // setBankDetailStatus(bankStatus);

    localStorage.setItem("check_id_verification_status", "false");

    var status = {
      identificationStatus: idStatus,
      userTierDocsStatus: idStatusTwo,
      bankDetailsStatus: bankStatus,
    };

    return status;
  } catch (error) {
    // if (error.response?.status === 401) {
    //
    // }
  }
};

export const getExchangeFeaturesCurrency = async () => {
  const loggedInCountry = localStorage.getItem("userCountry");

  try {
    const response = await axios.get(
      `${WEBSERVICE}home/getExchangeFeaturesCurrency/${loggedInCountry}/${localStorage.getItem(
        "BROKERID"
      )}`
    );

    const res = response.data;
    localStorage.setItem("homeCurrency", res.homeCurrency);
    localStorage.setItem("homeCurrencyId", res.homeCurrencyId);

    const matchedCurrency = currencySymbolList.find(
      (entry) => entry.currency === res.homeCurrency
    );

    const currencySymbol = matchedCurrency ? matchedCurrency.symbol : "";
    localStorage.setItem("homeCurrencySymbol", currencySymbol);

    localStorage.setItem("tradingFeesCurrency", res.tradingFeesCurrency);
    localStorage.setItem("tradingFeesCurrencyId", res.tradingFeesCurrencyId);
    return res;
    // Update state if needed
    // setCurrencySymbol(currencySymbol);
  } catch (error) {
    console.error("Error fetching exchange features currency:", error);
  }
};

// Modified function to accept navigate
export const deviceLogout = async (param, navigate) => {
  const infoObj = {
    uuid: localStorage.getItem("uuid"),
    deviceId: localStorage.getItem("deviceId"),
  };
  const BROKERID = localStorage.getItem("BROKERID");
  const DemoBroker = localStorage.getItem("DEMOBROKERID");

  try {
    const response = await axios.post(
      WEBSERVICE + "/user/" + param,
      JSON.stringify(infoObj),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      }
    );

    const result = response.data;

    if (result.error.error_data !== 0) {
      showToast("error", result.error.error_msg);
    } else {
      localStorage.clear();
      if (window.location.origin === DEMOBROKERDOMAIN) {
        console.log("demo");
        // console.log("brokerId--> 1", BROKERID);
        // localStorage.setItem("BROKERID", BROKERID);
        // localStorage.setItem("DEMOBROKERID", DemoBroker);
      } else {
        console.log("not demo");
      }
      localStorage.setItem("BROKERID", BROKERID);
      navigate("/");
      window.location.reload();
    }
  } catch (error) {
    console.error("Logout failed", error);
    showToast("error", "Logout failed");
  }
};

export function decryptMessages(message) {
  try {
    const reb64 = CryptoJS.enc.Hex.parse(message);
    const bytes = reb64.toString(CryptoJS.enc.Base64);
    const decrypted = CryptoJS.AES.decrypt(bytes, CHATSECRETKEY);
    const plainText = decrypted.toString(CryptoJS.enc.Utf8);

    return plainText || "Decryption failed";
  } catch (error) {
    console.error("Decryption error:", error);
    return "Error decrypting message";
  }
}

export function encryptMessages(plainText) {
  console.log("plainText", plainText, CHATSECRETKEY);
  try {
    const b64 = CryptoJS.AES.encrypt(
      plainText.toString(),
      CHATSECRETKEY
    ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const encryptData = e64.toString(CryptoJS.enc.Hex);
    console.log("encryptData", encryptData);
    return encryptData;
  } catch (error) {
    console.error("Encryption error:", error);
    return "Error encrypting message";
  }
}

export const tabsStyle = (btncolor) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: btncolor, // your custom color
    height: "2px", // optional: change thickness
    borderRadius: "2px", // optional: rounded edges
  },
  "& .MuiTab-root": {
    textTransform: "none", // prevent auto-capitalization
    color: "var(--text-color)",
  },
});

export const headerText = () => ({
  fontSize: "22px",
  color: "",
  fontStyle: "normal",
  fontWeight: "normal",
});
export const SubText = () => ({
  fontSize: "18px",
  color: "",
  fontStyle: "normal",
  fontWeight: "normal",
});
export const normalText = () => ({
  fontSize: "16px",
  color: "",
  fontStyle: "normal",
  fontWeight: "normal",
});

export default function CoreDataService() {
  return <div></div>;
}

export const checkInternetConnection = (onStatusChange) => {
  // Initialize current status
  const isOnline = navigator.onLine;

  // Handler when connection is restored
  const handleOnline = () => {
    console.log("Internet is back");
    onStatusChange(true);
  };

  // Handler when connection is lost
  const handleOffline = () => {
    console.log("Internet connection lost");
    onStatusChange(false);
  };

  // Attach event listeners
  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  // Immediately notify the current status
  onStatusChange(isOnline);

  // Return a cleanup function to remove listeners when not needed
  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
};

export const getAllBrokerMarkets = async (obj) => {
  const BROKERID = localStorage.getItem("BROKERID");
  const uuid = localStorage.getItem("uuid");
  const country = localStorage.getItem("userCountry");
  const token = localStorage.getItem("access_token");

  console.log("calling broker details");

  const inputObj = {
    brokerId: BROKERID,
    uuid,
    country,
  };

  try {
    const response = await axios.post(
      `${WEBSERVICE}user/brokerCryptoMarket`,
      JSON.stringify(inputObj),
      {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
      }
    );

    const res = response?.data;

    let updatedState = {
      brokerLogo: "./assets/loading-11.gif",
      isSpot: res.brokerCryptoMarket.spot,
      isFutures: res.brokerCryptoMarket.futures,
      isOptions: res.brokerCryptoMarket.options,
      isConvert: res.brokerCryptoMarket.convert,
      isOtc: res.brokerCryptoMarket.otc,
      isCopyTrade: res.brokerCryptoMarket.copyTrade,
      isPayment: res.brokerCryptoMarket.payments,
      isIco: res.brokerCryptoMarket.ico,
      isBank: res.brokerCryptoMarket.bank,
      isAssetMgmt: res.brokerCryptoMarket.assetManagement,
      isMiningPool: res.brokerCryptoMarket.miningPool,
      isNft: res.brokerCryptoMarket.nft,
      isP2p: res.brokerCryptoMarket.p2p,
      isWeb3Wallet: res.brokerCryptoMarket.web3Wallet,
      isHcNet: res.brokerCryptoMarket.hcNet,
    };

    const cm = res.countryModules;
    if (cm !== null && cm !== "null") {
      const modules = Object.keys(cm);
      modules.forEach((key) => {
        if (
          updatedState[`is${capitalizeFirstLetter(key)}`] === 1 &&
          cm[key] === 0
        ) {
          updatedState[`is${capitalizeFirstLetter(key)}`] = 0;
        }
      });
    }

    return checkSubUserPermission(updatedState, obj); // External function call
  } catch (error) {
    console.error("Error fetching broker markets:", error);
  }
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const checkSubUserPermission = (updatedState, obj) => {
  const parentId = localStorage.getItem("parentId");

  if (parentId && parentId !== "null" && parentId !== "undefined") {
    const permissionData = obj;

    const finalState = {
      ...updatedState,
      isSpot: updatedState.isSpot === 0 ? 0 : permissionData.spot,
      isFutures: updatedState.isFutures === 0 ? 0 : permissionData.futures,
      isOptions: updatedState.isOptions === 0 ? 0 : permissionData.options,
      isConvert: updatedState.isConvert === 0 ? 0 : permissionData.convert,
      isOtc: updatedState.isOtc === 0 ? 0 : permissionData.otc,
      isCopyTrade:
        updatedState.isCopyTrade === 0 ? 0 : permissionData.copyTrade,
      isPayment: 0, // Always 0 for subuser
      isIco: updatedState.isIco === 0 ? 0 : permissionData.ico,
      isBank: 0, // Always 0 for subuser
      isP2p: 0, // Always 0 for subuser
    };

    return finalState;
  }

  return updatedState;
};

export const checkCurrencyAccreditedStatus = async (
  userId,
  currencyCode,
  type,
  tradeAmount
) => {
  const token = localStorage.getItem("access_token");
  const uuid = localStorage.getItem("uuid");

  try {
    // First check if user is accredited (coinOwnerAccountType === '1')
    const userDetailsResponse = await axios.post(
      `${WEBSERVICE}user/GetUserDetails`,
      { uuid },
      {
        headers: {
          Authorization: `BEARER ${token}`,
        },
      }
    );

    if (
      userDetailsResponse?.data?.error?.error_data === 0 &&
      userDetailsResponse?.data?.userResult?.coinOwnerAccountType === "1"
    ) {
      return true;
    }

    const response = await axios.get(
      `${ACCREDITEDKYCWEBSERVICE}accreditation/check-currency-access`,
      {
        params: {
          userId,
          currencyCode,
          operationType: type,
          tradeAmount: tradeAmount || 0,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
      }
    );

    const res = response?.data;

    // Check if response is successful and has the expected structure
    if (res?.success && res?.data?.accessAllowed !== undefined) {
      return res.data.accessAllowed;
    }

    // Return false for unsuccessful responses or missing data
    return false;
  } catch (error) {
    console.error("Error checking currency accredited status:", error);
    return false;
  }
};

export const checkCurrencyPairAccreditedStatus = async (
  userId,
  counterCurrency,
  baseCurrency,
  operation,
  tradeAmount
) => {
  const token = localStorage.getItem("access_token");
  const uuid = localStorage.getItem("uuid");

  const deny = {
    accessAllowed: false,
    requiresTermsAgreement: false,
    links: null,
  };
  const allow = {
    accessAllowed: true,
    requiresTermsAgreement: false,
    links: null,
  };

  try {
    const userDetailsResponse = await axios.post(
      `${WEBSERVICE}user/GetUserDetails`,
      { uuid },
      {
        headers: {
          Authorization: `BEARER ${token}`,
        },
      }
    );

    const isCoinOwner =
      userDetailsResponse?.data?.error?.error_data === 0 &&
      userDetailsResponse?.data?.userResult?.coinOwnerAccountType === "1";

    const response = await axios.get(
      `${ACCREDITEDKYCWEBSERVICE}accreditation/check-trading-pair-access`,
      {
        params: {
          userId,
          tradingPair: `${counterCurrency}-${baseCurrency}`,
          operationType: operation,
          tradeAmount: tradeAmount || 0,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
      }
    );

    const res = response?.data;

    if (res?.success && res?.data) {
      const { baseCurrencyCheck, counterCurrencyCheck } = res.data;

      const bothAllowed =
        baseCurrencyCheck?.accessAllowed === true &&
        counterCurrencyCheck?.accessAllowed === true;

      if (!bothAllowed && !isCoinOwner) {
        return deny;
      }

      const baseLinks = Array.isArray(baseCurrencyCheck?.links)
        ? baseCurrencyCheck.links
        : [];
      const counterLinks = Array.isArray(counterCurrencyCheck?.links)
        ? counterCurrencyCheck.links
        : [];
      const seen = new Set();
      const combinedLinks = [...baseLinks, ...counterLinks].filter((l) => {
        if (!l || !l.url || seen.has(l.url)) return false;
        seen.add(l.url);
        return true;
      });

      if (combinedLinks.length > 0) {
        return {
          accessAllowed: true,
          requiresTermsAgreement: true,
          links: combinedLinks,
        };
      }

      return allow;
    }

    if (isCoinOwner) {
      return allow;
    }

    return deny;
  } catch (error) {
    console.error("Error checking currency pair accredited status:", error);
    return deny;
  }
};

export const handleDefaultAssetPair = (defaultAssetPair, force = false) => {
  if (!defaultAssetPair) return;

  localStorage.setItem("default_asset_pair", defaultAssetPair);

  let buying = "";
  let selling = "";

  const pairStr = defaultAssetPair.trim();
  if (pairStr.includes("-")) {
    const parts = pairStr.split("-");
    buying = parts[0];
    selling = parts[1];
  } else if (pairStr.includes("_")) {
    const parts = pairStr.split("_");
    buying = parts[0];
    selling = parts[1];
  } else if (pairStr.includes("/")) {
    const parts = pairStr.split("/");
    buying = parts[0];
    selling = parts[1];
  } else {
    // Match against known base currencies from right to left
    const knownBases = [
      "USDT",
      "USDC",
      "USD",
      "BTC",
      "ETH",
      "EUR",
      "INR",
      "AED",
      "GBP",
      "CAD",
      "JPY",
      "TRY",
      "BUSD",
      "DAI",
    ];
    const upperPair = pairStr.toUpperCase();
    let matched = false;
    for (const base of knownBases) {
      if (upperPair.endsWith(base)) {
        buying = upperPair.substring(0, upperPair.length - base.length);
        selling = base;
        matched = true;
        break;
      }
    }
    if (!matched) {
      if (upperPair.length > 6) {
        buying = upperPair.substring(0, upperPair.length - 4);
        selling = upperPair.substring(upperPair.length - 4);
      } else if (upperPair.length > 4) {
        buying = upperPair.substring(0, upperPair.length - 3);
        selling = upperPair.substring(upperPair.length - 3);
      } else {
        buying = upperPair;
        selling = "USDT";
      }
    }
  }

  if (buying && selling) {
    const buyLower = buying.toLowerCase();
    const sellLower = selling.toLowerCase();
    if (force || !localStorage.getItem("buying_crypto_asset")) {
      localStorage.setItem("buying_crypto_asset", buyLower);
      localStorage.setItem("O_buying_crypto_asset", buyLower);
      localStorage.setItem("selling_crypto_asset", sellLower);
      localStorage.setItem("O_selling_crypto_asset", sellLower);
      localStorage.setItem("selected_currency", buyLower);
    }
  }
};
